// assets
import {
    IconHistory,
    IconBlender,
    IconCarCrane,
    IconDashboard,
    IconGardenCart,
    IconList,
    IconWreckingBall,
    IconWriting,
    IconGrowth
} from '@tabler/icons-react';

// constant
const icons = {
    IconHistory,
    IconDashboard,
    IconGardenCart,
    IconList,
    IconCarCrane,
    IconWriting,
    IconBlender,
    IconWreckingBall,
    IconGrowth
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
    id: 'dashboard',
    title: '',
    type: 'group',
    children: [
        {
            id: 'default',
            title: 'Dashboard',
            type: 'item',
            url: '/civils/dashboard',
            icon: icons.IconDashboard,
            breadcrumbs: false
        },
        {
            id: 'analytics',
            title: 'Perfomance',
            type: 'item',
            url: '/civils/analytics',
            icon: icons.IconGrowth,
            breadcrumbs: false
        },
        {
            id: 'utils',
            title: 'Utilities',
            type: 'collapse',
            icon: icons.IconList,

            children: [
                {
                    id: 'suppliers',
                    title: 'Suppliers',
                    type: 'item',
                    url: '/civils/suppliers',
                    target: false
                },
                {
                    id: 'contractors',
                    title: 'Contractors',
                    type: 'item',
                    url: '/civils/contractors',
                    target: false
                }
            ]
        },
        {
            id: 'audit',
            title: 'Audit Logs',
            type: 'item',
            icon: icons.IconHistory,
            url: '/civils/audit-logs',
            target: false
        }
    ]
};

export default dashboard;
